const cardTypes = {
    AVTO: "avto",
    USER: "user"
}

export default cardTypes;